var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg89(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1768)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_1768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 6H14C11.7909 6 10 7.79086 10 10V28C10 30.2091 11.7909 32 14 32H32C34.2091 32 36 30.2091 36 28V10C36 7.79086 34.2091 6 32 6Z",
    fill: "#A92C2C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 2H14.0001C11.791 2 10.0001 3.79086 10.0001 6V24C10.0001 26.2091 11.791 28 14.0001 28H32.0001C34.2093 28 36.0001 26.2091 36.0001 24V6C36.0001 3.79086 34.2093 2 32.0001 2Z",
    fill: "#F13838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0806 20.15C17.2506 20.15 16.6106 19.93 16.1606 19.49C15.7206 19.04 15.5006 18.395 15.5006 17.555V16.625C15.5006 16.105 15.5856 15.67 15.7556 15.32C15.9256 14.96 16.2006 14.68 16.5806 14.48V14.45C16.2306 14.26 15.9706 14 15.8006 13.67C15.6406 13.33 15.5606 12.9 15.5606 12.38V11.945C15.5606 11.105 15.7756 10.465 16.2056 10.025C16.6456 9.575 17.2706 9.35 18.0806 9.35C18.8906 9.35 19.5106 9.575 19.9406 10.025C20.3806 10.465 20.6006 11.105 20.6006 11.945V12.38C20.6006 13.38 20.2606 14.07 19.5806 14.45V14.48C19.9606 14.68 20.2356 14.96 20.4056 15.32C20.5756 15.67 20.6606 16.105 20.6606 16.625V17.555C20.6606 18.395 20.4356 19.04 19.9856 19.49C19.5456 19.93 18.9106 20.15 18.0806 20.15ZM18.0806 13.775C18.6606 13.775 18.9506 13.425 18.9506 12.725V11.9C18.9506 11.2 18.6606 10.85 18.0806 10.85C17.5006 10.85 17.2106 11.2 17.2106 11.9V12.725C17.2106 13.425 17.5006 13.775 18.0806 13.775ZM18.0806 18.65C18.7006 18.65 19.0106 18.255 19.0106 17.465V16.46C19.0106 15.67 18.7006 15.275 18.0806 15.275C17.4606 15.275 17.1506 15.67 17.1506 16.46V17.465C17.1506 18.255 17.4606 18.65 18.0806 18.65ZM21.7014 18.41H23.2914V20H21.7014V18.41ZM26.8536 20.15C26.0536 20.15 25.4436 19.925 25.0236 19.475C24.6036 19.015 24.3936 18.36 24.3936 17.51V17.315H25.9536V17.615C25.9536 18.305 26.2386 18.65 26.8086 18.65C27.1186 18.65 27.3486 18.555 27.4986 18.365C27.6486 18.175 27.7236 17.84 27.7236 17.36V15.35H27.6936C27.4036 15.96 26.9036 16.265 26.1936 16.265C25.5936 16.265 25.1386 16.06 24.8286 15.65C24.5186 15.24 24.3636 14.645 24.3636 13.865V11.99C24.3636 11.15 24.5786 10.5 25.0086 10.04C25.4386 9.58 26.0586 9.35 26.8686 9.35C27.6786 9.35 28.2986 9.58 28.7286 10.04C29.1586 10.5 29.3736 11.15 29.3736 11.99V17.42C29.3736 19.24 28.5336 20.15 26.8536 20.15ZM26.8686 14.765C27.4386 14.765 27.7236 14.42 27.7236 13.73V11.87C27.7236 11.19 27.4386 10.85 26.8686 10.85C26.2986 10.85 26.0136 11.19 26.0136 11.87V13.73C26.0136 14.42 26.2986 14.765 26.8686 14.765Z",
    fill: "#111820"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_1768",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_1768"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_1768",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg89);
export default __webpack_public_path__ + "static/media/89.f4398f1b0b4a059bb69cad476f1ba28f.svg";
export { ForwardRef as ReactComponent };